import { render, staticRenderFns } from "./CardType.vue?vue&type=template&id=3a490482&scoped=true&"
import script from "./CardType.vue?vue&type=script&lang=js&"
export * from "./CardType.vue?vue&type=script&lang=js&"
import style0 from "./CardType.vue?vue&type=style&index=0&id=3a490482&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a490482",
  null
  
)

export default component.exports